import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

interface TotpFormProps {
  adminId: string;
  onSuccess: () => void;
  onBack: () => void;
}

export function TotpForm({ adminId, onSuccess, onBack }: TotpFormProps) {
  const { t } = useTranslation();
  const [token, setToken] = useState('');
  const [error, setError] = useState<string | null>(null);
  const { verifyTotp } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      await verifyTotp(adminId, token);
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Invalid TOTP code. Please try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3 className="card-title">{t('auth.two_factor_auth')}</h3>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <p className="text-muted">
        {t('auth.enter_totp')}
      </p>

      <div className="mb-3">
        <label htmlFor="totp" className="form-label">{t('auth.totp_code')}</label>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          className="form-control"
          id="totp"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          required
          maxLength={6}
          placeholder="123456"
        />
      </div>

      <button type="submit" className="btn btn-primary w-100">
        {t('auth.verify')}
      </button>

      <div className="mt-3 text-center">
        <button
          type="button"
          className="btn btn-link"
          onClick={onBack}
        >
          {t('auth.back_to_password')}
        </button>
      </div>
    </form>
  );
}
